import React, { useEffect, useState } from "react";
import RentalList from "../components/RentalList";
import CarRentalPricing from "../components/CarRentalPricing";
import { sanityClient } from "../lib/sanityClient";
import { Helmet } from "react-helmet-async";

const CarRentalPage = () => {
  const [rentals, setRentals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRentalData = async () => {
      try {
        const query = `*[_type == "carRental"]{
          _id, 
          vehicle->{title, brand, model, year, primaryImage}, 
          pricePerDay, 
          rentalTerms, 
          availability
        }`;
        
        const fetchedRentals = await sanityClient.fetch(query);
        console.log("Fetched Rentals:", fetchedRentals);
        setRentals(fetchedRentals);
      } catch (error) {
        console.error("Error fetching rental data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRentalData();
  }, []);

  if (loading) {
    return <div className="text-center mt-8">Loading...</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Cars for rent in Cameroon</title>
        <meta name="description" content="Affordable car rentals available for short and long-term use in all major towns and cities in Cameroon." />
      </Helmet>

      {/* Car Rental Pricing Section */}
      

      {/* Rental Listings */}
      <div className="mt-8">
        <h2 className="text-3xl font-bold text-center mb-6">Available Car Rentals in Cameroon</h2>
        {rentals.length > 0 ? (
          <RentalList rentals={rentals} />
        ) : (
          <p className="text-center text-gray-500">No car rentals available at the moment.</p>
        )}
      </div>
      <CarRentalPricing/>
      <p>237 Mechanic offers the best Car rental services in Cameroon. Our rates are very competitive. our cars are in top condition no added charges. Our Terms and conditions are very straight forward.</p>
    </div>
  );
};

export default CarRentalPage;
